import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/shared/Button";

import RegistrationStep from "../../../components/shared/RegistrationStep";

import { USER_ROLES } from "../../../utils/UIProvider";

import SuccessPage from "components/shared/SuccessPage";
import SchoolSearch from "components/shared/SchoolSearch";

export const TeacherRegisteration = () => {
  const [currentPath, setCurrentPath] = useState("registerAccount");
  const [state, setState] = useState<any>({
    role: USER_ROLES.TEACHER,
  });

  const navigate = useNavigate();

  return (
    <div>
      {currentPath == "findSchool" && (
        <SchoolSearch
          eventName="SIGNUP_STUDENTS_FIND_YOUR_SCHOOL_INDEX"
          title={"FIND YOUR SCHOOL"}
          onNext={(school: any) => {
            setState((old: any) => ({ ...old, ...school }));
          }}
          value={{ ...state }}
        />
      )}

      {currentPath === "registerAccount" && (
        <RegistrationStep
          value={{
            ...state,
          }}
          onBack={() => navigate("/")}
          onNext={() => {
            setCurrentPath("success");
          }}
        />
      )}

      {currentPath === "success" && (
        <SuccessPage button="Go to teacher dashboard" value={{ ...state }} />
      )}
    </div>
  );
};
